import { render, staticRenderFns } from "./edit-role.vue?vue&type=template&id=2e881a6e&"
import script from "./edit-role.vue?vue&type=script&lang=js&"
export * from "./edit-role.vue?vue&type=script&lang=js&"
import style0 from "./edit-role.vue?vue&type=style&index=0&id=2e881a6e&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports